import Modal from "@/components/shared/modal";
import { useState, Dispatch, SetStateAction, useCallback, useMemo } from "react";
import { IS_MAIN_SITE } from "@/components/shared/sites/sites";
import { getLocalizedPath } from "@/components/shared/formatURL";

type SignInModalProps = {
  showSignInModal: boolean;
  setShowSignInModal: Dispatch<SetStateAction<boolean>>;
  translations: any;
};

const SignInModal = ({ showSignInModal, setShowSignInModal, translations }: SignInModalProps) => {
  return (
    <Modal showModal={showSignInModal} setShowModal={setShowSignInModal}>
      <div className="w-full overflow-hidden border-0 border-[#3C3C3C] shadow-xl sm:border-[0.5px] md:max-w-md md:rounded-2xl">
        <div className="flex flex-col items-center justify-center space-y-3 border-b border-b-[0.5px] border-[#3C3C3C] bg-[#202124] px-4 py-6 text-center md:px-16">
          <p
            className="animate-text bg-gradient-to-r from-[#FF6200] via-[#FFCC18] to-[#FFCC18] bg-clip-text
                text-center font-semibold 
                uppercase  text-transparent [text-decoration:none]"
          >
            {translations.accessViaPremium}
          </p>
        </div>
        <div className="flex flex-col space-y-4 bg-[#313338] px-4 py-6 md:px-16">
          <a
            className="mt-auto w-full lg:mb-auto lg:mt-auto lg:w-auto"
            target="_blank"
            rel="noopener noreferrer"
            href={getLocalizedPath("upgrade") + "?ref=modal"}
          >
            <button className="focus-visible:ring-ring ring-offset-background my-0 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-[#FFCC18] px-4 py-2 text-sm font-black italic text-black transition duration-500 ease-in-out [text-decoration:none] hover:scale-105 hover:bg-[#FF6200] hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
              {IS_MAIN_SITE ? translations.upgradeCCBill1Dollar : translations.upgradeSubStar}
            </button>
          </a>
        </div>
      </div>
    </Modal>
  );
};

export function useUpgradeModal(translations: any) {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const UpgradeModalCallback = useCallback(() => {
    return (
      <SignInModal
        showSignInModal={showUpgradeModal}
        setShowSignInModal={setShowUpgradeModal}
        translations={translations}
      />
    );
  }, [showUpgradeModal, setShowUpgradeModal]);

  return useMemo(
    () => ({ setShowUpgradeModal, UpgradeModal: UpgradeModalCallback }),
    [setShowUpgradeModal, UpgradeModalCallback],
  );
}
